require('./bootstrap');

import Vue from 'vue';
import VueRouter from 'vue-router'
import App from './components/Visitor.vue';
import VisitorRegister from './components/Visitor/VisitorRegister.vue';
import VisitorLogin from './components/Visitor/VisitorLogin.vue';
import HeaderTitle from './components/Common/HeaderTitle.vue';
import Sink from './components/Common/Sink.vue';


Vue.config.devtools = true;
Vue.config.performance = true;


import hu from 'vee-validate/dist/locale/hu.json';

import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'hu',
    messages: {
        hu: {
            validations: {
                ...hu.messages,
                'sanetext': 'A(z) {_field_} nem tartahlamzhat mást, mint betűk, szóköz, aposztróf, pont, kötőjel.',
                'password': 'A(z) {_field_} nem elég erős. Tartalmaznia kell legalább egy kisbetűt, egy nagybetűt.',
                'phone': 'A(z) {_field_} nem tűnik érvényes magyar telefonszámnak.',
                'url': 'Érvénytelen url.',
            },
            ...require('vuetify/src/locale/hu.ts').default,
            ...require('./trans/hu.json')
        }
    },
});
window.i18n = i18n;
import {lochelper} from './stuff/hu-i18n';

lochelper(i18n);


import {extend, ValidationProvider, ValidationObserver, localize, configure} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules';

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
localize('hu', {hu})

const routes = [
    {path: '/regisztracio', component: VisitorRegister},
    {path: '/belepes', component: VisitorLogin},
    {path: '/sink', component: Sink},
];
Vue.use(VueRouter)
const router = new VueRouter({routes})

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
configure({
    defaultMessage: (field, values) => {
        return i18n.t(`validations.${values._rule_}`, values);
    }
});
extend('sanetext', {
    validate(value) {
        return value.match(/^[A-zÀ-ÿ '.-]+$/u);
    },
});
extend('password', {
    validate: value => /^(?=.*[a-z])(?=.*[A-Z])/.test(value)
});
extend('phone', {
    validate: value => /^((?:\+?3|0)6)[-(]?(\d{1,2})[-)]?(\d{3})-?(\d{3,4})$/.test(value)
});
extend('url', {
    validate: (value, [host]) => {
        const res = value.match(/^(https?:\/\/)?([\w\-])+\.([a-zA-Z]{2,63})[\/\w-]*\/?\??([^#\n\r]*)?#?([^\n\r]*)$/);
        return res && (!host || res[2] && res[2].match(host) || res[3] && res[3].match(host));
    }
});

import Vuetify from 'vuetify';

Vue.use(Vuetify);
const vuetify = new Vuetify({
    lang: {
        locales: {hu:i18n.messages.hu},
        current: 'hu',
    },
    theme: {
        themes: {
            light: {
                primary: '#3fac69',
            },
        },
    },
});
Vue.component('HeaderTitle',HeaderTitle);

const app = new Vue({
    router,
    vuetify,
    i18n,

    components: {
        App,
        VisitorRegister,
        VisitorLogin,
    },
    render: h => h(App)
}).$mount('#app');
